"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const video_client_core_1 = require("@video/video-client-core");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const styling_1 = require("../../../../styling");
const utils_1 = require("../../../../styling/utils");
const Select_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/Select"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const ModularVideoDeviceSelect = (0, mobx_react_lite_1.observer)(({ classes = {}, ...props }) => {
    var _a;
    const { label } = props;
    const componentName = "<VideoDeviceSelect/>";
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null, componentName);
    const selectRef = (0, react_1.createRef)();
    /**
     * On input change handler to (1) update API and (2) update component
     * <select> value with user selected video device.
     */
    const selectCamera = (ev) => {
        ctx.mediaStreamController.resolution = null;
        ctx.mediaStreamController.videoDeviceId = ev.target.value;
    };
    // Use global Error handler (to trigger ErrorBoundary).
    const handleInputChange = (0, ErrorBoundary_1.useUIEventError)(selectCamera, componentName);
    const deviceInUse = (id) => video_client_core_1.mediaController.devicesInUse.some((d) => d.deviceId === id);
    return (react_1.default.createElement(Select_1.default, { classes: mergedStyles, ref: selectRef, onChange: handleInputChange, value: (_a = ctx.mediaStreamController.videoDeviceId) !== null && _a !== void 0 ? _a : "", label: label !== null && label !== void 0 ? label : "Camera", ...props },
        react_1.default.createElement("option", { disabled: true, value: "" }, "Select a camera"),
        video_client_core_1.mediaController.videoDevices().map((item, key) => {
            var _a;
            return (react_1.default.createElement("option", { key: item.deviceId, value: item.deviceId, className: mergedClasses.options, disabled: deviceInUse(item.deviceId) }, (_a = item.label) !== null && _a !== void 0 ? _a : `Camera ${key + 1}`,
                " ",
                deviceInUse(item.deviceId) && "In Use"));
        })));
});
function VideoDeviceSelectWithErrorBoundary({ classes = {}, ...props }) {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => {
            var _a;
            return (react_1.default.createElement(Select_1.default, { ...props, disabled: true, classes: mergedStyles, label: "Video device unavailable" },
                react_1.default.createElement("option", { value: "", className: mergedClasses === null || mergedClasses === void 0 ? void 0 : mergedClasses.options }, (_a = props.fallbackText) !== null && _a !== void 0 ? _a : "Video Devices Unavailable")));
        } },
        react_1.default.createElement(ModularVideoDeviceSelect, { classes: classes, ...props })));
}
exports.default = VideoDeviceSelectWithErrorBoundary;
//# sourceMappingURL=VideoDeviceSelect.js.map